import { Lock } from "lucide-react";
import { Link } from "react-router";

import { ROTA_INICIAL_LEITURA } from "../commons/somenteLeitura";

export const AcessoNaoPermitido = () => (
  <div className="flex min-h-[60vh] flex-col items-center justify-center gap-3 text-center">
    <Lock className="h-8 w-8 text-muted-foreground" aria-hidden />
    <h1 className="text-[22px] font-bold tracking-[-0.025em]">Acesso não permitido</h1>
    <p className="max-w-sm text-sm text-muted-foreground">Tela fora do perfil de acesso.</p>
    <Link to={ROTA_INICIAL_LEITURA} className="text-sm font-medium text-primary hover:underline">
      Ir para Vendas
    </Link>
  </div>
);
